
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/location-voiture-vtc-lyon",
      function () {
        return require("private-next-pages/location-voiture-vtc-lyon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/location-voiture-vtc-lyon"])
      });
    }
  